import React from 'react';
import { observer, inject } from 'mobx-react';
import { Spring } from 'react-spring';

import Container from './Container';
import Title from './Title';
import FullNameInput from './FullNameInput';
import ContinueButton from 'js/components/core/SteppedPage/ContinueButton';
import {AvFeedback, AvInput} from "availity-mobx-reactstrap-validation";
import userCountry from "js/services/UserCountry";
import AvGroup from "js/components/pages/BuyerSignupPage/FullName/NameEntry/FullNameInput/AvGroup";

export default inject('page')(
  observer(({ page, animate }) => (
    <Spring
      native
      from={animate ? { opacity: 0, transform: 'translate3d(0,2rem,0)' } : { opacity: 0 }}
      to={animate ? { opacity: 1, transform: 'translate3d(0,0rem,0)' } : { opacity: 1 }}>
      {animation => (
        <Container style={animation}>
          <Title>What is your name?</Title>
          <FullNameInput name="full_name" value={page.full_name} onChange={page.setFullName} placeholder={'Enter your full name'} required />
        </Container>
      )}
    </Spring>
  )),
);
